export const SET_WIDGET_RISE = "footer/SET_WIDGET_RISE";

export function setWidgetRise(set = false) {
  return {
    type: SET_WIDGET_RISE,
    set
  };
}
